<template>
    <div>
        <!-- <button-back/> -->
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box torrea">
                <h1 class="caption__select">
                    <!-- <span>{{img.name}}</span> -->
                    <!-- <span>Seleccione un departamento, clic para ver detalles</span> -->
                </h1>
                
               <!--  <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel" :levelId="levelId" :url="url" /> -->
               <!--  <div class="line_horizontal"></div> -->
               <div>
                    <image-location class="image__location-small" :typeImage="typeImage" :urlImg="urlImg"/>
                    <detail-location :typeImage="typeImage"/>
                    <btn-detail style="margin-top:2rem" @clickBtn="openM()" />
               </div>
               <DetailModal :modalShow="modal" @modalHide="closeM">
                <template slot="title-detail">{{ modelDpt.name }}</template>
                 <template slot="content-detail">
                    <Detail />
                 </template>
               </DetailModal>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
//import MapHighlight from "../../core/torreairea/MapHighlight";
//import ButtonBack from "../../core/ButtonBack";
//import Button from "../../core/Button.vue";
import ImageLocation from "../../../core/rediseno/ImageIndividual";
import DetailLocation from "../../../core/rediseno/DetailLocation";
import BtnDetail from "../../../core/rediseno/BtnDetail.vue";
import DetailModal from "../../../core/rediseno/modal/DetailModal";
import Detail from "../dataillocation/Main.vue"
export default {
    name: "Casa",
    components: {
       // MapHighlight,
        ImageLocation,
        DetailLocation,
        BtnDetail,
        DetailModal,
        Detail
       // Button,
        //ButtonBack,
    },
    data() {
        return {
            id: 34,
            levelId: this.$route.params.idPiso,
            type: "casas",
            desarrollo: "canadas_casas-priv",
            arrFilteredLocations: [],
            nivel: "availability",
           
            //image adition
            typeImage: "modeloCasas",
            urlImg: "ca%C3%B1adas/casas/modelos",
            //
           
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            //add
            modal:false
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos",
            levelDept:"getStatusLevel",
            modelDpt:'getStatusA'

        }),
        development() {
            return { id: this.id, level: this.levelDept.id };
        },
        img() {
            const nivel = this.$route.params.piso;
            const nivelSeleccionado = this.niveles[nivel];
            return nivelSeleccionado;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords", "getFilterModelos"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        },
        openM(){
            this.modal=true
        },
        closeM(){
            this.modal=false
        },
        
    },
    async created() {
        /* await this.getAvailableLocations(this.development);
        this.getFilterModelos(this.existFilter) */
    },
    async beforeDestroy() {
        await this.clearCoords();
    },
    mounted() {

    }
};
</script>
<style>
@media (min-width:1201px) {
    .maphighlight__box.torrea{
    width: 60%;   
    }
}
</style>